/* Wishlist maison Cyber Techwear (remplace Swish) — 25/10/2026.
   Liste gardée dans le navigateur (localStorage « ct_wl »). Client connecté : chaque ajout / retrait part dans CT Mail
   (signé par le thème) et sa liste le suit sur tous ses appareils. Visiteur : il peut laisser son email sur la page
   « My wishlist » pour la sauvegarder. Aucun envoi de mail n'est déclenché ici. */
(function () {
  var CLE = 'ct_wl', CLE_EMAIL = 'ct_wl_email', C = window.CTWL || {};

  function lire() { try { return JSON.parse(localStorage.getItem(CLE)) || []; } catch (e) { return []; } }
  function ecrire(l) { try { localStorage.setItem(CLE, JSON.stringify(l.slice(0, 60))); } catch (e) {} }
  function contient(l, h) { return l.some(function (x) { return x.h === h; }); }
  function emailVisiteur() { try { return localStorage.getItem(CLE_EMAIL) || ''; } catch (e) { return ''; } }

  function envoyer(action, items, email, marketing) {
    var corps = { action: action, items: items };
    if (marketing) corps.marketing = true;
    if (C.client) { corps.email = C.client.email; corps.client_id = String(C.client.id); corps.sig = C.client.sig; }
    else if (email || emailVisiteur()) { corps.email = email || emailVisiteur(); }
    else if (action !== 'lire') { return Promise.resolve(null); }
    return fetch(C.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps), keepalive: true })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  // Compteur anonyme pour les statistiques de CT Mail : produit + type de clic, aucune donnée personnelle.
  function compter(evenement, h) {
    if (!C.api || !h) return;
    fetch(C.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ action: 'compter', evenement: evenement, connu: !!(C.client || emailVisiteur()), items: [{ handle: h }] })
    }).catch(function () {});
  }

  function maj() {
    var l = lire();
    document.querySelectorAll('[data-ct-wl]').forEach(function (b) {
      var on = contient(l, b.getAttribute('data-handle'));
      b.classList.toggle('is-actif', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lib = b.querySelector('[data-ct-wl-libelle]');
      if (lib) lib.textContent = on ? b.getAttribute('data-libelle-on') : b.getAttribute('data-libelle-off');
    });
    document.querySelectorAll('[data-ct-wl-compte]').forEach(function (n) {
      n.textContent = l.length; n.hidden = l.length === 0;
    });
  }

  function basculer(b) {
    var h = b.getAttribute('data-handle'), v = b.getAttribute('data-variante') || '', l = lire();
    if (contient(l, h)) {
      l = l.filter(function (x) { return x.h !== h; });
      envoyer('retrait', [{ handle: h }]);
      compter('retrait', h);
    } else {
      l.unshift({ h: h, v: v, t: Date.now() });
      envoyer('ajout', [{ handle: h, variante_id: v }]);
      compter('ajout', h);
    }
    ecrire(l); maj(); rendrePage();
  }

  // Les cartes sont souvent ajoutées après coup (filtres, « voir plus ») : délégation sur le document.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ct-wl]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    basculer(b);
  }, true);

  // Client connecté : fusion de la liste du navigateur et de celle enregistrée (autres appareils).
  function fusionClient() {
    if (!C.client) return Promise.resolve();
    var local = lire();
    if (local.length) envoyer('ajout', local.map(function (x) { return { handle: x.h, variante_id: x.v }; }));
    return envoyer('lire', []).then(function (r) {
      if (!r || !r.items) return;
      var l = lire();
      r.items.forEach(function (it) { if (!contient(l, it.handle)) l.push({ h: it.handle, v: it.variante_id ? String(it.variante_id).split('/').pop() : '', t: 0 }); });
      ecrire(l); maj(); rendrePage();
    });
  }

  // ---------------- page « My wishlist » (section ct-wishlist-page)
  function prix(cents) {
    try { return new Intl.NumberFormat(C.locale || 'en', { style: 'currency', currency: C.devise || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function echapper(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  var rendu = 0;
  function rendrePage() {
    var zone = document.querySelector('[data-ct-wl-page]');
    if (!zone) return;
    var l = lire(), n = ++rendu, vide = document.querySelector('[data-ct-wl-vide]'), grille = zone.querySelector('[data-ct-wl-grille]');
    if (vide) vide.hidden = l.length > 0;
    var form = document.querySelector('[data-ct-wl-form]');
    if (form) form.hidden = !!C.client || l.length === 0 || !!emailVisiteur();
    if (!l.length) { grille.innerHTML = ''; return; }
    Promise.all(l.map(function (x) {
      return fetch((C.racine || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(x.h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      if (n !== rendu) return;
      PRODUITS = {};
      grille.innerHTML = ps.map(function (p, i) {
        if (!p) return '';
        PRODUITS[p.handle] = p;
        var url = (C.racine || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(p.handle);
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        var v = varianteDepart(p, l[i] && l[i].v);
        var noms = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
        var selects = noms.length && !(noms.length === 1 && /^title$/i.test(noms[0]) && p.variants.length === 1) ? noms.map(function (nom, k) {
          var valeurs = [];
          p.variants.forEach(function (x) { if (valeurs.indexOf(x.options[k]) < 0) valeurs.push(x.options[k]); });
          return '<label class="ct-wl-opt"><span>' + echapper(nom) + '</span><select data-ct-wl-opt="' + k + '">' + valeurs.map(function (val) {
            var dispo = p.variants.some(function (x) { return x.options[k] === val && x.available; });
            return '<option value="' + echapper(val) + '"' + (v && v.options[k] === val ? ' selected' : '') + '>' + echapper(val) + (dispo ? '' : ' (sold out)') + '</option>';
          }).join('') + '</select></label>';
        }).join('') : '';
        return '<div class="ct-wl-carte" data-ct-wl-carte="' + echapper(p.handle) + '">' +
          '<a href="' + url + '"><img src="' + echapper(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + echapper(p.title) + '" loading="lazy"></a>' +
          '<button type="button" class="ct-wl-coeur is-actif" data-ct-wl data-handle="' + echapper(p.handle) + '" aria-label="Remove from wishlist" aria-pressed="true">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.7 4.5c2.1 0 3.6 1.2 4.3 2.4h2c.7-1.2 2.2-2.4 4.3-2.4 3.7 0 5.8 3.9 4.3 7.3C19.5 16.4 12 21 12 21z"/></svg></button>' +
          '<a class="ct-wl-titre" href="' + url + '">' + echapper(p.title) + '</a>' +
          '<div class="ct-wl-prix" data-ct-wl-prix>' + prixVariante(v || p) + '</div>' + selects +
          '<div data-ct-wl-zone>' + boutonAchat(v) + '</div>' +
          '<form class="ct-wl-notify-form" data-ct-wl-notify-form hidden><input type="email" required placeholder="Your email" autocomplete="email" aria-label="Your email"><button type="submit">OK</button></form>' +
          '<p class="ct-wl-msg" data-ct-wl-msg hidden></p></div>';
      }).join('');
    });
  }

  // ---------------- couleur / taille + ajout au panier depuis la wishlist (Nicolas 25/10)
  var PRODUITS = {};
  // Taille épuisée : « Notify me when it's back » au lieu de « Sold out » (Nicolas 27/10 : « mettre dans la wishlist le
  // notify me sur les produits qu'ils ont et qui sont OOS »). Client connecté ou email déjà donné : un clic.
  var CLE_ALERTES = 'ct_wl_alertes', CLE_EMAIL_ALERTE = 'ct_wl_email_alerte';
  function alertes() { try { return JSON.parse(localStorage.getItem(CLE_ALERTES)) || []; } catch (e) { return []; } }
  function emailAlerte() {
    if (C.client && C.client.email) return C.client.email;
    try { return localStorage.getItem(CLE_EMAIL_ALERTE) || emailVisiteur(); } catch (e) { return emailVisiteur(); }
  }
  function boutonAchat(v) {
    if (v && v.available) return '<button type="button" class="ct-wl-acheter" data-ct-wl-panier>Add to cart</button>';
    if (!v) return '<button type="button" class="ct-wl-acheter" data-ct-wl-panier disabled>Unavailable</button>';
    var deja = alertes().indexOf(String(v.id)) > -1;
    return '<button type="button" class="ct-wl-acheter ct-wl-notify" data-ct-wl-notify' + (deja ? ' disabled' : '') + '>' +
      (deja ? "✓ We'll email you" : "Notify me when it's back") + '</button>';
  }
  function demanderAlerte(carte, v, email) {
    var zone = carte.querySelector('[data-ct-wl-zone]'), msg = carte.querySelector('[data-ct-wl-msg]');
    var b = zone.querySelector('button'); if (b) { b.disabled = true; b.textContent = '…'; }
    var corps = new URLSearchParams({ email: email, variante_id: String(v.id), handle: carte.getAttribute('data-ct-wl-carte'),
                                      titre: v.title || '', consentement: '1' });
    fetch((C.api || '').replace(/\/hooks\/wishlist.*$/, '/hooks/alerte-stock'), { method: 'POST', body: corps })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.ok) throw new Error('refus');
        var l = alertes(); if (l.indexOf(String(v.id)) < 0) l.push(String(v.id));
        try { localStorage.setItem(CLE_ALERTES, JSON.stringify(l.slice(-100))); } catch (e) {}
        zone.innerHTML = boutonAchat(v); msg.hidden = true;
        var f = carte.querySelector('[data-ct-wl-notify-form]'); if (f) f.hidden = true;
      })
      .catch(function () { zone.innerHTML = boutonAchat(v); msg.hidden = false; msg.textContent = 'Please check your email and try again.'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ct-wl-notify]'); if (!b || b.disabled) return;
    var carte = b.closest('[data-ct-wl-carte]'), v = varianteChoisie(carte); if (!v) return;
    var email = emailAlerte();
    if (email) { demanderAlerte(carte, v, email); return; }
    var f = carte.querySelector('[data-ct-wl-notify-form]'); f.hidden = false; f.querySelector('input').focus();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-ct-wl-notify-form]'); if (!f) return;
    e.preventDefault();
    var email = (f.querySelector('input').value || '').trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { f.querySelector('input').reportValidity(); return; }
    try { localStorage.setItem(CLE_EMAIL_ALERTE, email); } catch (er) {}
    var carte = f.closest('[data-ct-wl-carte]'), v = varianteChoisie(carte); if (v) demanderAlerte(carte, v, email);
  });
  function prixVariante(v) {
    var barre = v.compare_at_price && v.compare_at_price > v.price ? '<s>' + prix(v.compare_at_price) + '</s> ' : '';
    return barre + '<b>' + prix(v.price) + '</b>';
  }
  function varianteDepart(p, idGarde) {
    var g = idGarde && p.variants.filter(function (x) { return String(x.id) === String(idGarde); })[0];
    if (g && g.available) return g;
    return p.variants.filter(function (x) { return x.available; })[0] || g || p.variants[0];
  }
  function varianteChoisie(carte) {
    var p = PRODUITS[carte.getAttribute('data-ct-wl-carte')]; if (!p) return null;
    var choix = [].map.call(carte.querySelectorAll('[data-ct-wl-opt]'), function (s) { return s.value; });
    if (!choix.length) return p.variants[0];
    return p.variants.filter(function (x) { return choix.every(function (c, k) { return x.options[k] === c; }); })[0] || null;
  }
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-ct-wl-opt]'); if (!s) return;
    var carte = s.closest('[data-ct-wl-carte]'), v = varianteChoisie(carte);
    if (v) carte.querySelector('[data-ct-wl-prix]').innerHTML = prixVariante(v);
    carte.querySelector('[data-ct-wl-zone]').innerHTML = boutonAchat(v);
    var nf = carte.querySelector('[data-ct-wl-notify-form]'); if (nf) nf.hidden = true;
    if (v) { var l = lire(); l.forEach(function (x) { if (x.h === carte.getAttribute('data-ct-wl-carte')) x.v = String(v.id); }); ecrire(l); }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ct-wl-panier]'); if (!b || b.disabled) return;
    var carte = b.closest('[data-ct-wl-carte]'), v = varianteChoisie(carte), msg = carte.querySelector('[data-ct-wl-msg]');
    if (!v) return;
    b.disabled = true; b.textContent = 'Adding…';
    var fini = function (ok) {
      if (ok) compter('panier', carte.getAttribute('data-ct-wl-carte'));
      b.disabled = false; b.textContent = ok ? 'Added ✓' : 'Add to cart';
      msg.hidden = !!ok; msg.textContent = ok ? '' : 'Could not add to cart, please try again.';
      setTimeout(function () { if (b.textContent === 'Added ✓') b.textContent = 'Add to cart'; }, 2500);
    };
    // Panier du thème (même module que le bouton de la fiche) : met à jour le compteur et ouvre le panier latéral.
    import('cart-store').then(function (m) {
      return m.default.add({ id: v.id, quantity: 1 }).then(function () {
        var cart = document.querySelector('.modal--cart, .popup--cart-notification');
        if (cart && !cart.shown && cart.open) cart.open();
        fini(true);
      });
    }).catch(function () {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) { if (r.ok) { compter('panier', carte.getAttribute('data-ct-wl-carte')); window.location.href = '/cart'; } else { fini(false); } }).catch(function () { fini(false); });
    });
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-ct-wl-form]');
    if (!f) return;
    e.preventDefault();
    var email = (f.querySelector('input[type=email]') || {}).value || '';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return;
    var bouton = f.querySelector('button'), coche = f.querySelector('input[type=checkbox]'), msg = f.querySelector('[data-ct-wl-ok]');
    bouton.disabled = true;
    envoyer('synchro', lire().map(function (x) { return { handle: x.h, variante_id: x.v }; }), email.trim().toLowerCase(), !!(coche && coche.checked))
      .then(function (r) {
        var reussi = !!(r && r.ok);
        if (reussi) { try { localStorage.setItem(CLE_EMAIL, email.trim().toLowerCase()); } catch (er) {} }
        else { bouton.disabled = false; }
        if (msg) { msg.hidden = false; msg.textContent = reussi ? '✓ Saved. Your wishlist is safe.' : 'Could not save, please try again.'; }
      });
  });

  // Fiche produit : le bouton est rendu en fin de colonne ; on le remonte juste sous « Add to cart ».
  function placerBoutonFiche() {
    var b = document.querySelector('.ct-wl-bouton'), bloc = document.querySelector('.product-single__box__block--buy_buttons');
    if (b && bloc && b.parentElement !== bloc) bloc.appendChild(b);
  }
  function demarrer() { placerBoutonFiche(); maj(); rendrePage(); fusionClient(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  // Cartes chargées plus tard (filtres AJAX, carrousels) : on remet l'état des cœurs à jour.
  new MutationObserver(function () { clearTimeout(window.__ctwlT); window.__ctwlT = setTimeout(maj, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
